import type { CSSProperties } from '@linaria/core'
import { WHITEBOARDSTATE } from '.'
import { Whiteboard } from '../../types/state'
import { WhiteboardEvent } from '../constants/enums'
import { pubSubWhiteboard } from './pubSub'

const emitWhiteboardUpdate = (whiteboard: Whiteboard, immediate = true) => {
    WHITEBOARDSTATE.whiteboard = whiteboard
    // WHITEBOARDSTATE.identifier = state.identifier
    // WHITEBOARDSTATE.loading = state.loading
    // WHITEBOARDSTATE.open = state.open
    // WHITEBOARDSTATE.showAvatar = state.showAvatar
    // WHITEBOARDSTATE.style = state.style
    pubSubWhiteboard.emit(WhiteboardEvent.UPDATE, whiteboard, immediate)
}

export const openWhiteboard = (
    identifier: string | number,
    showAvatar?: boolean,
    style?: CSSProperties,
) => {
    const whiteboardState = {
        ...WHITEBOARDSTATE.whiteboard,
        identifier,
        open: true,
        showAvatar,
        style,
    }
    emitWhiteboardUpdate(whiteboardState, true)
}

export const closeWhiteboard = () => {
    const whiteboardState = {
        ...WHITEBOARDSTATE,
        open: false,
    }
    emitWhiteboardUpdate(whiteboardState, true)
}
